<template>
  <div class="share_render">
    <div v-if="displayStyle === 'tile'" class="share_tile">
      <template v-if="$store.state.app.language == 'zh-cn'">
        <a href="javascript:void(0);" class="share_tile_icon share_tile_weixin" @click="shareToWx" v-if="shareType.find(item => item === 'weixin')">
          <i class="iconfont icon-weixin"></i>
        </a>
        <a href="javascript:void(0);" class="share_tile_icon share_tile_weibo" @click="shareToSinaWB" v-if="shareType.find(item => item === 'weibo')">
          <i class="iconfont icon-weibo-copy1"></i>
        </a>
        <a href="javascript:void(0);" class="share_tile_icon share_tile_qq" @click="shareToqq" v-if="shareType.find(item => item === 'qq')">
          <i class="iconfont icon-qq"></i>
        </a>
      </template>
      <template v-else>
        <img v-if="shareType.find(item => item === 'twitter')" class="share_tile_icon a2a_button_twitter a2a_svg" src="https://sitecdn.71360.com/static/txys-001/wm/image/share/twitter_new.png?my_version_number=123" alt="twitter">
        <span v-if="shareType.find(item => item === 'wechat')" class="share_tile_icon a2a_button_wechat"><span class="a2a_svg a2a_s__default a2a_s_wechat" style="background-color: rgb(123, 179, 46);"><svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g fill="#FFF"><path d="M20.674 12.458c-2.228.116-4.165.792-5.738 2.318-1.59 1.542-2.315 3.43-2.116 5.772-.87-.108-1.664-.227-2.462-.294-.276-.023-.602.01-.836.14-.774.438-1.517.932-2.397 1.482.16-.73.266-1.37.45-1.985.137-.45.074-.7-.342-.994-2.673-1.89-3.803-4.714-2.958-7.624.78-2.69 2.697-4.323 5.302-5.173 3.555-1.16 7.55.022 9.712 2.845a6.632 6.632 0 0 1 1.38 3.516zm-10.253-.906c.025-.532-.44-1.01-.984-1.027a.997.997 0 0 0-1.038.964.984.984 0 0 0 .977 1.02 1.017 1.017 0 0 0 1.05-.96zm5.35-1.028c-.55.01-1.01.478-1 1.012.01.554.466.987 1.03.98a.982.982 0 0 0 .99-1.01.992.992 0 0 0-1.02-.982z"></path><path d="M25.68 26.347c-.705-.314-1.352-.785-2.042-.857-.686-.072-1.408.324-2.126.398-2.187.224-4.147-.386-5.762-1.88-3.073-2.842-2.634-7.2.92-9.53 3.16-2.07 7.795-1.38 10.022 1.493 1.944 2.51 1.716 5.837-.658 7.94-.687.61-.934 1.11-.493 1.917.086.148.095.336.14.523zm-8.03-7.775c.448 0 .818-.35.835-.795a.835.835 0 0 0-.83-.865.845.845 0 0 0-.84.86c.016.442.388.8.834.8zm5.176-1.658a.83.83 0 0 0-.824.794c-.02.47.347.858.813.86.45 0 .807-.34.823-.79a.825.825 0 0 0-.812-.864z"></path></g></svg></span></span>
        <span v-if="shareType.find(item => item === 'facebook')" class="share_tile_icon a2a_button_facebook"><span class="a2a_svg a2a_s__default a2a_s_facebook" style="background-color: rgb(24, 119, 242);"><svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill="#FFF" d="M17.78 27.5V17.008h3.522l.527-4.09h-4.05v-2.61c0-1.182.33-1.99 2.023-1.99h2.166V4.66c-.375-.05-1.66-.16-3.155-.16-3.123 0-5.26 1.905-5.26 5.405v3.016h-3.53v4.09h3.53V27.5h4.223z"></path></svg></span></span>
        <span v-if="shareType.find(item => item === 'linkedin')" class="share_tile_icon a2a_button_linkedin"><span class="a2a_svg a2a_s__default a2a_s_linkedin" style="background-color: rgb(0, 123, 181);"><svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M6.227 12.61h4.19v13.48h-4.19V12.61zm2.095-6.7a2.43 2.43 0 0 1 0 4.86c-1.344 0-2.428-1.09-2.428-2.43s1.084-2.43 2.428-2.43m4.72 6.7h4.02v1.84h.058c.56-1.058 1.927-2.176 3.965-2.176 4.238 0 5.02 2.792 5.02 6.42v7.395h-4.183v-6.56c0-1.564-.03-3.574-2.178-3.574-2.18 0-2.514 1.7-2.514 3.46v6.668h-4.187V12.61z" fill="#FFF"></path></svg></span></span>
      </template>
    </div>
    <div v-else-if="$store.state.app.language !== 'zh-cn' && $store.state.app.view_pattern === 'mb'" class="share">
      <i class="u-icon iconfont icon-fenxiang" @click="openAmpShare"></i>
      <div :class="['share_popup', popupActived ? 'actived' : '']">
        <button class="share_popup_bg" @click="closeAmpShare"></button>
        <div class="share_wrapper">
          <img v-if="shareType.find(item => item === 'twitter')" style="margin-right: 4px;" class="a2a_button_twitter a2a_svg" src="https://sitecdn.71360.com/static/txys-001/wm/image/share/twitter_new.png?my_version_number=123" alt="twitter">
          <span v-if="shareType.find(item => item === 'wechat')" class="share_icon a2a_button_wechat" ><span class="a2a_svg a2a_s__default a2a_s_wechat" style="background-color: rgb(123, 179, 46);"><svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g fill="#FFF"><path d="M20.674 12.458c-2.228.116-4.165.792-5.738 2.318-1.59 1.542-2.315 3.43-2.116 5.772-.87-.108-1.664-.227-2.462-.294-.276-.023-.602.01-.836.14-.774.438-1.517.932-2.397 1.482.16-.73.266-1.37.45-1.985.137-.45.074-.7-.342-.994-2.673-1.89-3.803-4.714-2.958-7.624.78-2.69 2.697-4.323 5.302-5.173 3.555-1.16 7.55.022 9.712 2.845a6.632 6.632 0 0 1 1.38 3.516zm-10.253-.906c.025-.532-.44-1.01-.984-1.027a.997.997 0 0 0-1.038.964.984.984 0 0 0 .977 1.02 1.017 1.017 0 0 0 1.05-.96zm5.35-1.028c-.55.01-1.01.478-1 1.012.01.554.466.987 1.03.98a.982.982 0 0 0 .99-1.01.992.992 0 0 0-1.02-.982z"></path><path d="M25.68 26.347c-.705-.314-1.352-.785-2.042-.857-.686-.072-1.408.324-2.126.398-2.187.224-4.147-.386-5.762-1.88-3.073-2.842-2.634-7.2.92-9.53 3.16-2.07 7.795-1.38 10.022 1.493 1.944 2.51 1.716 5.837-.658 7.94-.687.61-.934 1.11-.493 1.917.086.148.095.336.14.523zm-8.03-7.775c.448 0 .818-.35.835-.795a.835.835 0 0 0-.83-.865.845.845 0 0 0-.84.86c.016.442.388.8.834.8zm5.176-1.658a.83.83 0 0 0-.824.794c-.02.47.347.858.813.86.45 0 .807-.34.823-.79a.825.825 0 0 0-.812-.864z"></path></g></svg></span></span>
          <span v-if="shareType.find(item => item === 'facebook')" class="share_icon a2a_button_facebook" ><span class="a2a_svg a2a_s__default a2a_s_facebook" style="background-color: rgb(24, 119, 242);"><svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill="#FFF" d="M17.78 27.5V17.008h3.522l.527-4.09h-4.05v-2.61c0-1.182.33-1.99 2.023-1.99h2.166V4.66c-.375-.05-1.66-.16-3.155-.16-3.123 0-5.26 1.905-5.26 5.405v3.016h-3.53v4.09h3.53V27.5h4.223z"></path></svg></span></span>
          <span v-if="shareType.find(item => item === 'linkedin')" class="share_icon a2a_button_linkedin"><span class="a2a_svg a2a_s__default a2a_s_linkedin" style="background-color: rgb(0, 123, 181);"><svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M6.227 12.61h4.19v13.48h-4.19V12.61zm2.095-6.7a2.43 2.43 0 0 1 0 4.86c-1.344 0-2.428-1.09-2.428-2.43s1.084-2.43 2.428-2.43m4.72 6.7h4.02v1.84h.058c.56-1.058 1.927-2.176 3.965-2.176 4.238 0 5.02 2.792 5.02 6.42v7.395h-4.183v-6.56c0-1.564-.03-3.574-2.178-3.574-2.18 0-2.514 1.7-2.514 3.46v6.668h-4.187V12.61z" fill="#FFF"></path></svg></span></span>
        </div>
      </div>
    </div>
    <div v-else class="g-share-render-box">
      <div class="news_share_info jz_share_info">
        <span class="jz_share_text news_share_text faisco-icons-S000258" @click="openShare">
          <!-- <i class="u-icon iconfont icon-fenxiang large-click-btn"></i> -->
          <i class="u-icon iconfont icon-fenxiang" :class="{'large-click-btn': largeShow}"></i>
         
          <span class="u-share_title">{{ getLang(title) }}</span>
        </span>
        <div class="jz_share_wrap" 
        v-if="(shareType.indexOf('whatsapp') == -1 && shareType.length > 0 && isPc)
          || (shareType.length > 3 && shareType.indexOf('whatsapp') > -1 && isPc)">
          <div class="jz_share_layout"></div>
          <div class="jz_share_list">
            <template v-if="$store.state.app.language == 'zh-cn'">
              <a hidefocus="true" :title="$t('components_my_share_render_2439')" href="javascript:void(0);" class="jz_share_icon jz_share_Weixin" @click="shareToWx" v-if="shareType.find(item => item === 'weixin')">
                <div class="jz_share_name">{{$t('components_my_share_render_2440')}}</div>
                <i class="u-icon iconfont icon-weixin"></i>
              </a>
              <a hidefocus="true" :title="$t('components_my_share_render_2441')" href="javascript:void(0);" class="jz_share_icon jz_share_sina_weibo" @click="shareToSinaWB" v-if="shareType.find(item => item === 'weibo')">
                <div class="jz_share_name">{{$t('components_my_share_render_2442')}}</div>
                <i class="u-icon iconfont icon-weibo-copy1"></i>
              </a>
              <a hidefocus="true" :title="$t('components_my_share_render_2443')" href="javascript:void(0);" class="jz_share_icon jz_share_qq_share" @click="shareToqq" v-if="shareType.find(item => item === 'qq')">
                <div class="jz_share_name">QQ</div>
                <i class="u-icon iconfont icon-qq"></i>
              </a>
            </template>
            <template v-else>
              <div style="display: flex;flex-wrap: wrap;">
                <img v-if="shareType.find(item => item === 'twitter')" style="margin-right: 10px;" class="a2a_button_twitter a2a_svg" src="https://sitecdn.71360.com/static/txys-001/wm/image/share/twitter_new.png?my_version_number=123" alt="twitter">
                <span v-if="shareType.find(item => item === 'wechat')" style="margin-right: 10px;" class="a2a_button_wechat" ><span class="a2a_svg a2a_s__default a2a_s_wechat" style="background-color: rgb(123, 179, 46);"><svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g fill="#FFF"><path d="M20.674 12.458c-2.228.116-4.165.792-5.738 2.318-1.59 1.542-2.315 3.43-2.116 5.772-.87-.108-1.664-.227-2.462-.294-.276-.023-.602.01-.836.14-.774.438-1.517.932-2.397 1.482.16-.73.266-1.37.45-1.985.137-.45.074-.7-.342-.994-2.673-1.89-3.803-4.714-2.958-7.624.78-2.69 2.697-4.323 5.302-5.173 3.555-1.16 7.55.022 9.712 2.845a6.632 6.632 0 0 1 1.38 3.516zm-10.253-.906c.025-.532-.44-1.01-.984-1.027a.997.997 0 0 0-1.038.964.984.984 0 0 0 .977 1.02 1.017 1.017 0 0 0 1.05-.96zm5.35-1.028c-.55.01-1.01.478-1 1.012.01.554.466.987 1.03.98a.982.982 0 0 0 .99-1.01.992.992 0 0 0-1.02-.982z"></path><path d="M25.68 26.347c-.705-.314-1.352-.785-2.042-.857-.686-.072-1.408.324-2.126.398-2.187.224-4.147-.386-5.762-1.88-3.073-2.842-2.634-7.2.92-9.53 3.16-2.07 7.795-1.38 10.022 1.493 1.944 2.51 1.716 5.837-.658 7.94-.687.61-.934 1.11-.493 1.917.086.148.095.336.14.523zm-8.03-7.775c.448 0 .818-.35.835-.795a.835.835 0 0 0-.83-.865.845.845 0 0 0-.84.86c.016.442.388.8.834.8zm5.176-1.658a.83.83 0 0 0-.824.794c-.02.47.347.858.813.86.45 0 .807-.34.823-.79a.825.825 0 0 0-.812-.864z"></path></g></svg></span></span>
                <span v-if="shareType.find(item => item === 'facebook')" style="margin-right: 10px;" class="a2a_button_facebook" ><span class="a2a_svg a2a_s__default a2a_s_facebook" style="background-color: rgb(24, 119, 242);"><svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill="#FFF" d="M17.78 27.5V17.008h3.522l.527-4.09h-4.05v-2.61c0-1.182.33-1.99 2.023-1.99h2.166V4.66c-.375-.05-1.66-.16-3.155-.16-3.123 0-5.26 1.905-5.26 5.405v3.016h-3.53v4.09h3.53V27.5h4.223z"></path></svg></span></span>
                <span v-if="shareType.find(item => item === 'linkedin')" class="a2a_button_linkedin"><span class="a2a_svg a2a_s__default a2a_s_linkedin" style="background-color: rgb(0, 123, 181);"><svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M6.227 12.61h4.19v13.48h-4.19V12.61zm2.095-6.7a2.43 2.43 0 0 1 0 4.86c-1.344 0-2.428-1.09-2.428-2.43s1.084-2.43 2.428-2.43m4.72 6.7h4.02v1.84h.058c.56-1.058 1.927-2.176 3.965-2.176 4.238 0 5.02 2.792 5.02 6.42v7.395h-4.183v-6.56c0-1.564-.03-3.574-2.178-3.574-2.18 0-2.514 1.7-2.514 3.46v6.668h-4.187V12.61z" fill="#FFF"></path></svg></span></span>
              </div>
            </template>
          </div>
        </div>
      </div>
      <el-dialog :title="$t('components_my_share_render_2439')" :visible.sync="dialogVisible" width="300px" modal-append-to-body>
        <div class="u-img-box">
          <img :src="wxQrCode" style="width: 80%"/>
        </div>
      </el-dialog>
      <div class="m-share-box" :data-active="activeShare" @click="closeShare">
        <div class="u-mn">
          <a hidefocus="true" :title="$t('components_my_share_render_2439')" href="javascript:void(0);" class="jz_share_icon jz_share_Weixin" @click.stop="shareToWx" v-if="shareType.find(item => item === 'weixin')">
            <i class="u-icon iconfont icon-weixin"></i>
            <span class="u-sn">{{$t('components_my_share_render_2440')}}</span>
          </a>
          <a hidefocus="true" :title="$t('components_my_share_render_2441')" href="javascript:void(0);" class="jz_share_icon jz_share_sina_weibo" @click.stop="shareToSinaWB" v-if="shareType.find(item => item === 'weibo')">
            <i class="u-icon iconfont icon-weibo-copy1"></i>
            <span class="u-sn">{{$t('components_my_share_render_2442')}}</span>
          </a>
          <a hidefocus="true" :title="$t('components_my_share_render_2443')" href="javascript:void(0);" class="jz_share_icon jz_share_qq_share" @click.stop="shareToqq" v-if="shareType.find(item => item === 'qq')">
            <i class="u-icon iconfont icon-qq"></i>
            <span class="u-sn">QQ</span>
          </a>
        </div>
      </div>
    </div>
    <div class="m-tips" :data-active="activeTips">
      <img class="u-img" src="./../../assets/image/shareIcon.png"/>
      <p class="u-p">{{$t('components_my_share_render_2444')}}</p>
      <button class="u-btn" type="button" @click="closeTips">{{$t('components_my_share_render_2445')}}</button>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

  import Cookies from 'js-cookie'
  export default {
    name: 'my_share',
    components: {}, // 注册组件
    directives: {},
    props: {
      shareType: {
        type: Array,
        default: () => []
      },
      title: {
        type: String,
        default: i18n.t('components_my_share_render_2446')
      },
      largeShow: {
        type: Boolean,
        default: true
      },
      displayStyle: {
        type: String,
        default: 'default'
      }
      
    },
    data() {
      return {
        popupActived: false,
        formInline: {
          channelName: '',
          page: {
            total: 0,
            pageSize: 10,
            currentPage: 1
          }
        },
        wxQrCode: '',
        dialogVisible: false,
        activeShare: false,
        activeTips: false,
        filter: {
          listingNameOptions: []
        },
        tableTile: [],
        loading: true,
        tableData: []
      }
    },
    computed: {
      isPc () {
        return this.$store.state.app.view_pattern === 'pc'
      },
      isMobile () {
        return this.$store.state.app.view_pattern === 'mb'
      },
      isAmp() {
        if(this.$store.state.app.language === 'en-us' && this.$store.state.app.view_pattern === 'mb') {
          return true
        } else {
          return false
        }
      }
    },
    methods: {
      shareToWx (event) {
        if (this.isMobile) return this.activeTips = true
        this.dialogVisible = true
        this.wxQrCode = process.env.BASE_API + '/admin/home/getQrcode?url=' + escape(this.$store.state.preview.path) + '&admin-token=' + Cookies.get('admin_token_wm')
      },
      shareToSinaWB (event) {
        var _title,_source,_sourceUrl,
          _url = 'http://www.baidu.com',
          _pic = 'http://www.newsucai.cn/static/home/images/jpg/__header.jpg'
        event.preventDefault()
        let _shareUrl = 'http://v.t.sina.com.cn/share/share.php?title="123"' // 真实的appkey，必选参数
        _shareUrl += '&url='+ encodeURIComponent(_url||document.location) // 参数url设置分享的内容链接|默认当前页location，可选参数
        _shareUrl += '&title=' + encodeURIComponent(_title||document.title) // 参数title设置分享的标题|默认当前页标题，可选参数
        _shareUrl += '&source=' + encodeURIComponent(_source||'')
        _shareUrl += '&sourceUrl=' + encodeURIComponent(_sourceUrl||'')
        _shareUrl += '&content=' + 'utf-8' // 参数content设置页面编码gb2312|utf-8，可选参数
        _shareUrl += '&pic=' + encodeURIComponent(_pic||'') // 参数pic设置图片链接|默认为空，可选参数
        window.open(_shareUrl,'_blank')
      },
      shareToqq (event) {
        if (this.isMobile) return this.activeTips = true
        var _title,
          _url = 'http://www.baidu.com'
        event.preventDefault()
        let _shareUrl = 'https://connect.qq.com/widget/shareqq/iframe_index.html?'
        _shareUrl += 'url=' + encodeURIComponent(_url||location.href) // 分享的链接
        _shareUrl += '&title=' + encodeURIComponent(_title||document.title) // 分享的标题
        window.open(_shareUrl,'_blank')
      },
      openShare () {
        if (this.isMobile && this.shareType.length) this.activeShare = true
      },
      closeShare () {
        this.activeShare = false
      },
      openAmpShare() {
        if((this.shareType.indexOf('whatsapp') == -1 && this.shareType.length > 0)
          || (this.shareType.length > 3 && this.shareType.indexOf('whatsapp') > -1)) {
            this.popupActived = true
          }
      },
      closeAmpShare() {
        this.popupActived = false
      },
      closeTips () {
        this.activeTips = false
        this.activeShare = false
      },
      openTips() {
        this.activeTips = true
        this.closeAmpShare()
      }
    }
  }
</script>

<style scoped lang="scss">
.share_render {
  .share_tile {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .share_tile_icon {
      margin-right: 10px;
      cursor: pointer;
      &.share_tile_weixin {
        color: #46d42f;
        font-size: 24px;
      }
      &.share_tile_weibo {
        color: #f44336;
        font-size: 24px;
      }
      &.share_tile_qq {
        color: #2992fc;
        font-size: 24px;
      }
    }
    .a2a_svg {
      background-repeat: no-repeat;
      display: block;
      overflow: hidden;
      height: 32px;
      line-height: 32px;
      padding: 0;
      width: 32px;
      border-radius: 50%;
    }
  }
  .a2a_svg {
    background-repeat: no-repeat;
    display: block;
    overflow: hidden;
    height: 32px;
    line-height: 32px;
    padding: 0;
    width: 32px;
    border-radius: 50%;
}
  .share {
    .icon-fenxiang {
      border: none;
      background: transparent;
      font-size: 24px;
    }
    .share_popup {
      position: fixed;
      bottom: 0;
      left: 0;
      height: 0;
      width: 100%;
      z-index: 99999;
      overflow: hidden;
      transition: 0.5s background-color, 0s 0.5s height;
      &.actived {
        height: 100%;
        transition: 0.3s background-color;
        .share_popup_bg {
          background-color: rgba(0, 0, 0, 0.5);
        }
        .share_wrapper {
          transform: translateY(0);
        }
      }
      .share_popup_bg {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0);
        transition: 0.5s background-color;
        border: none;
      }
      .share_wrapper {
        overflow: hidden;
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 2%;
        line-height: 32px;
        display: flex;
        align-items: center;
        background: #fff;
        .share_icon {
          padding: 4px;
          line-height: 16px;
          img {
            height: 26px;
          }
          &.linkedin {
            line-height: 57px;
            background-color: #0077b5;
          }
          &.twitter {
            line-height: 60px;
            background-color: #1da1f2;
            img {
              height: 24px;
            }
          }
          &.line {
            line-height: 58px;
            background-color: #52b448;
          }
        }
      }
    }
  }
  .g-share-render-box {
    .news_share_info {
      align-items: center;
      position: relative;
    }
    .jz_share_info:hover .jz_share_wrap {
      display: block;
    }
    .jz_share_info {
      /*position: absolute;*/
      line-height: 35px;
    }
    .news_share_text {
      font-size: 13px;
      color: #666;
      vertical-align: middle;
      white-space: nowrap;
      line-height: 1.5;
      cursor: pointer;
      .u-icon {
        margin-right: 10px;
        font-size: 16px;
      }
    }
    .news_share_text:before {
      /*margin-right: 10px;*/
      /*content: '\b0258';*/
    }
    .jz_share_text {
      position: relative;
    }
    &[data-device='mb'] .news_share_text {
      font-size: 14px;
    }
    .jz_share_info .jz_share_wrap {
      display: none;
    }
    &[data-device='mb'] .jz_share_info .jz_share_wrap {
      display: none;
    }
    .jz_share_list {
      z-index: 2200;
      position: absolute;
      right: -30px;
      top: 35px;
      width: 190px;
      max-width: 190px;
      padding: 15px;
      vertical-align: middle;
      border-radius: 5px;
      box-shadow: 0 0 20px rgba(0,0,0,.15);
      background: #fff;
      white-space: normal;
    }
    .jz_share_list:before {
      z-index: 1;
      content: '';
      display: inline-block;
      position: absolute;
      top: -4px;
      right: 48px;
      width: 10px;
      height: 10px;
      background: #fff;
      transform: rotate(45deg);
    }
    .jz_share_icon {
      display: inline-block;
      margin: 5px;
      vertical-align: middle;
      font-size: 30px;
    }
    .faisco-icons-S000142:before {
      content: '\b0142';
    }
    .jz_share_icon:before {
      /*content: '\b0142';*/
    }
    .jz_share_Weixin {
      color: #46d42f;
    }
    .jz_share_sina_weibo {
      color: #f44336;
    }
    .jz_share_qq_share {
      color: #2992fc;
    }
    .u-icon {
      margin: 5px 5px 0 0;
      font-size: 30px;
    }
    .jz_share_name {
      display: none;
      color: #333;
    }

    .u-img-box {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .m-share-box {
      overflow: hidden;
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 2210;
      width: 100%;
      height: 0;
      background-color: rgba(0, 0, 0, 0);
      transition: .3s background-color, 0s .3s height;
      &[data-active] {
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        transition: .3s background-color;
      }
      &[data-active] .u-mn {
        bottom: 0;
      }
      .u-mn {
        display: flex;
        position: absolute;
        bottom: -128px;
        left: 0;
        padding-top: 24px;
        padding-left: 3%;
        padding-right: 3%;
        width: 100%;
        background-color: #fff;
        transition: .3s bottom;
        .jz_share_icon {
          display: flex;
          font-size: 38px;
          margin: 0 11px 10px;
          text-align: center;
          width: 48px;
          flex-direction: column;
          justify-content: center;
        }
        .u-icon {
          margin: 0;
          font-size: 38px;
        }
        .u-sn {
          display: block;
          font-size: 12px;
          line-height: 37px;
          color: #333;
        }
      }
    }
  }
  .m-tips {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
    width: 100%;
    height: 100%;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    &[data-active] {
      display: flex;
    }
    .u-img {
      margin-top: 100px;
      margin-bottom: 26px;
      width: 200px;
    }
    .u-p {
      width: 234px;
      text-align: center;
      color: #666;
      font-size: 16px;
      margin-bottom: 36px;
    }
    .u-btn {
      height: 50px;
      width: 150px;
      text-align: center;
      line-height: 50px;
      border: 1px solid #e0e0e0;
      font-size: 18px;
      color: #666;
      border-radius: 4px;
      background-color: #fff;
      cursor: pointer;
      box-sizing: border-box;
    }
  }
}
.large-click-btn{
  position: relative;
  &::after{
    content: '';
    position: absolute;
    top: -20px;
    right: -20px;
    bottom: -20px;
    left: -20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_share/render.vue